import {
    UrlTls
} from './UrlTls';
import Router from '../../router';
// import Router from '../router';
const LineTls = {
    // conds: {
    //     'new_ssc': 0,
    //     'LV-Wire-Cu-6': 0,
    //     'LV-Wire-Cu-10': 0,
    //     'LV-Wire-Cu-16': 0,
    //     'LV-Wire-Cu-25': 0,
    //     'LV-Wire-Cu-35': 0,
    //     'LV-Wire-Cu-50': 0
    // },
    sumCuLine(lineObj){
        var conds = {
            'new_ssc': 0,
            'LV-Wire-Cu-6': 0,
            'LV-Wire-Cu-10': 0,
            'LV-Wire-Cu-16': 0,
            'LV-Wire-Cu-25': 0,
            'LV-Wire-Cu-35': 0,
            'LV-Wire-Cu-50': 0
        };

        for (var n in conds) {
            if (lineObj['n_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineObj['real_length']);
            if (lineObj['r_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineObj['real_length']);
            if (lineObj['s_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineObj['real_length']);
            if (lineObj['t_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineObj['real_length']);
            if (lineObj['l_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineObj['real_length']);
        }

        return conds;

    },
    sumCuLines(lineArr) {

        var conds = {
            'new_ssc': 0,
            'LV-Wire-Cu-6': 0,
            'LV-Wire-Cu-10': 0,
            'LV-Wire-Cu-16': 0,
            'LV-Wire-Cu-25': 0,
            'LV-Wire-Cu-35': 0,
            'LV-Wire-Cu-50': 0
        };

        for (let i = 0; i < lineArr.length; i++) {
            if (lineArr[i].cond_type.search('س') > 0) {

                for (var n in conds) {
                    if (lineArr[i]['n_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineArr[i]['real_length']);
                    if (lineArr[i]['r_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineArr[i]['real_length']);
                    if (lineArr[i]['s_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineArr[i]['real_length']);
                    if (lineArr[i]['t_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineArr[i]['real_length']);
                    if (lineArr[i]['l_spec'].toLowerCase() == n.toLowerCase().split("_").join("-")) conds[n] += eval(lineArr[i]['real_length']);
                }

                conds.new_ssc += eval(lineArr[i]['real_length']);
                // console.log(lineArr[i]['length']);
            }
        }

        for (n in conds) {
            // conds[n]--;
            conds[n] = Math.round(conds[n] * 100) / 100;
        }

        return conds;

        // if (lineRow.cond_type.search('س') > 0) {
        //     cType = lineRow.cond_type;





        //     var l = '';

        //     for (var prop in types) {
        //         if (prop && prop != "0") {
        //             if (l != '') l += '+';
        //             if (types[prop] > 1) l += types[prop] + 'x';
        //             l += Math.abs(prop.slice(-2));
        //         }
        //     }


        //     // n_spec
        //     // r_spec
        //     // s_spec
        //     // t_spec
        //     // l_spec

        //     cType = l;


        // }


    },

    convertRow2Cond(lineRow) {
        // row of json to conductor label

        var cType = '';
        if (lineRow.cond_type.search('س') > 0) {
            cType = lineRow.cond_type;


            // var conds = { 'LV-Wire-Cu-6': 0, 'LV-Wire-Cu-10': 1, 'LV-Wire-Cu-16': 2, 'LV-Wire-Cu-25': 3, 'LV-Wire-Cu-35': 4 };
            // var arrCuConds = [6, 10, 16, 25, 35];
            // var nCuConds = [0, 0, 0, 0, 0];

            // nCuConds[conds[Math.abs(lineRow.n_spec.slice(-2))]]++;
            // nCuConds[conds[Math.abs(lineRow.l_spec.slice(-2))]]++;
            // nCuConds[conds[Math.abs(lineRow.r_spec.slice(-2))]]++;
            // nCuConds[conds[Math.abs(lineRow.S_SPEC.slice(-2))]]++;
            // nCuConds[conds[Math.abs(lineRow.t_spec.slice(-2))]]++;
            // nCuConds[conds[lineRow.n_spec]]++;
            // nCuConds[conds[lineRow.l_spec]]++;
            // nCuConds[conds[lineRow.r_spec]]++;
            // nCuConds[conds[lineRow.S_SPEC]]++;
            // nCuConds[conds[lineRow.t_spec]]++;


            var types = {};
            // vvv = ['n_spec','l_spec','S_SPEC','r_spec','t_spec'];
            // for(i=0;i<5;i++){
            //     if(lineRow[vvv[i]]){
            //         if(types[lineRow[vvv[i]]])  types[lineRow[vvv[i]]]++;
            //         else types[lineRow[vvv[i]]] = 1;
            //     }

            // }
            if (types[lineRow.n_spec]) types[lineRow.n_spec]++;
            else types[lineRow.n_spec] = 1;
            if (types[lineRow.l_spec]) types[lineRow.l_spec]++;
            else types[lineRow.l_spec] = 1;
            if (types[lineRow.r_spec]) types[lineRow.r_spec]++;
            else types[lineRow.r_spec] = 1;
            if (types[lineRow.s_spec]) types[lineRow.s_spec]++;
            else types[lineRow.s_spec] = 1;
            if (types[lineRow.t_spec]) types[lineRow.t_spec]++;
            else types[lineRow.t_spec] = 1;





            var l = '';
            // for (i = nCuConds.length - 1; i >= 0; i--) {
            //     if (nCuConds[i] > 0) {
            //         if (l != '') l += '+';
            //         l += nCuConds[i] + "x" + arrCuConds[i];
            //     }
            // }
            // Math.abs(n_spec.slice(-2))


            for (var prop in types) {
                if (prop && prop != "0") {
                    if (l != '') l += '+';
                    if (types[prop] > 1) l += types[prop] + 'x';
                    l += Math.abs(prop.slice(-2));
                }
            }


            // n_spec
            // r_spec
            // s_spec
            // t_spec
            // l_spec

            cType = l;


        } else if (lineRow.cond_type.search("خ") > 0) {
            cType = 'SSC' + lineRow.s_spec.substring(lineRow.s_spec.length - 2, lineRow.s_spec.length);
        } else {
            // lLable = "";
        }



        return cType;

    },

    getLineStyle(lineRow) {
        if (lineRow.cond_type.search('س') > 0 || lineRow.isnew > 0) {
            return {
                color: '#111',
                weight: '2',
                dashArray: '7,7',
                // text:'sdauj da nkdjas '
            };

        } else if (lineRow.cond_type.search('خ') > 0) {
            return {
                color: '#111',
                weight: '2',
                // dashArray:'6,6',,
                // text:'sdauj da nkdjas '
            };
            // cType = 'SSC'+lineRow.s_spec.substring(lineRow.S_SPEC.length - 2,lineRow.S_SPEC.length);
        } else {
            return {
                color: '#555',
                weight: '1',
                // dashArray:'6,6',,
                // text:'sdauj da nkdjas '
            };
        }
    },

    getLineTmpStyle() {
        return {
            color: '#ddd',
            weight: '.5',
            // dashArray: '7,7',
            // text:'sdauj da nkdjas '
        };
    },
    getInfo(lineRow) {
        
        let info = '';
        // info += '<b>' + lineRow.height + "/" + lineRow.weight + '</b><br/>';
        // if (lineRow.codition) info += lineRow.codition + '<br>';
        info += "Feeder ID: " + lineRow.feeder_id + "<br/>";
        info += "Length:    " + lineRow.length + "<br/>";
        info += "REAL Length:    " + lineRow.real_length + "<br/>";
        info += '<br><a target="_blank" href="#/simple-edit/lv_lines/_id/' + lineRow._id + '" >اطلاعات</a> ';
        info += '<br><a target="_blank" href="#/simple-edit-d/lv_lines/_id/' + lineRow._id + '" >سطح مقطع</a>';

        info += '<form action="' + UrlTls.getBaseUrl() + '/free/lv_lines/_id/' + lineRow._id + '" target="_blank"  method="POST"><input name="real_length" value="' + lineRow.real_length + '"/></form>';


        
        var feederNewId = Router.currentRoute._rawValue.params.feederId;

        info += "<br><span>سطح مقطع</span>";
        info += '<br><a href="' + UrlTls.getBaseUrl() + '/lv_lines/add-feeder/' + lineRow._id +'/'+feederNewId+ '">افزودن فیدر</a>';
        info += '<a href="' + UrlTls.getBaseUrl() + '/lv_lines/remove-feeder/' + lineRow._id +'/'+feederNewId +'">حذف فیدر</a>';

        info += '<br><form action="' + UrlTls.getBaseUrl() + '/free/lv_lines/_id/' + lineRow._id;
        info += '" target="_blank"  method="POST">';
        info += '<input name="n_spec" value="' + lineRow.n_spec + '"/>';
        info += '<input name="l_spec" value="' + lineRow.l_spec + '"/>';
        info += '<input name="r_spec" value="' + lineRow.r_spec + '"/>';
        info += '<input name="s_spec" value="' + lineRow.s_spec + '"/>';
        info += '<input name="t_spec" value="' + lineRow.t_spec + '"/>';
        info += '<input name="cond_type" value="' + lineRow.cond_type + '"/>';
        info += '<input type="submit" value="سطح مقطع"/>';
        info += '</form>';

        return info;

    },
};

export {
    LineTls
}